import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProcessoJudicialService } from '../../service/processo/processo-judicial.service';

@Component({
  selector: 'app-input-processo',
  templateUrl: './input-processo.component.html',
  styleUrls: ['./input-processo.component.css']
})
export class InputProcessoComponent implements OnInit, OnDestroy {
  @Input() formulario: FormGroup;
  @Input() readonly: boolean = false;

  isNotNumber = false;
  numeroDoProcessoValido: boolean;
  numeroDoProcessoInvalido: boolean;
  isNotValidNumeroProcesso = false;


  constructor(private processoService: ProcessoJudicialService) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    if (this.formulario) {
      const control = this.formulario.get('numeroProcessoJudicial');
      if (control) {
        control.reset(null);
        control.setErrors(null);
        control.markAsPristine();
        control.markAsUntouched();
        control.updateValueAndValidity();
      }
    }
    this.numeroDoProcessoValido = false;
    this.numeroDoProcessoInvalido = false;
    this.isNotNumber = false;
    this.isNotValidNumeroProcesso = false;
  }

  maskNumeroProcesso(numeroProcesso: string) {

    let numeroProcessoApenasNumeros = numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');


    if (numeroProcessoApenasNumeros.length >= 13 && numeroProcessoApenasNumeros.charAt(13) !== '8') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcessoApenasNumeros.length >= 14 && numeroProcessoApenasNumeros.charAt(14) !== '1') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcessoApenasNumeros.length >= 15 && numeroProcessoApenasNumeros.charAt(15) !== '3') {

      this.isNotValidNumeroProcesso = true;

      return;

    }

    this.isNotValidNumeroProcesso = numeroProcessoApenasNumeros.length > 20;
    this.formulario.controls.numeroProcessoJudicial.setValue(numeroProcessoApenasNumeros);

    if (numeroProcessoApenasNumeros && numeroProcessoApenasNumeros.length >= 20 && numeroProcessoApenasNumeros.length < 25) {
      let resultado: any;
      numeroProcessoApenasNumeros = numeroProcessoApenasNumeros.toString();
      numeroProcessoApenasNumeros = numeroProcessoApenasNumeros.replace('-', '');
      numeroProcessoApenasNumeros = numeroProcessoApenasNumeros.replace('.', '');

      resultado = numeroProcessoApenasNumeros.split('');
      resultado.splice(7, 0, '-');
      resultado.splice(10, 0, '.');
      resultado.splice(15, 0, '.');
      resultado.splice(17, 0, '.');
      resultado.splice(20, 0, '.');
      numeroProcessoApenasNumeros = resultado.join('');
      this.formulario.controls.numeroProcessoJudicial.setValue(numeroProcessoApenasNumeros);
    }else{
      this.formulario.controls.numeroProcessoJudicial.setErrors({
        invalido: true
      });
    }
  }

  async buscarProcesso() {
    var qtdeDigitosProcesso = 0;

    if(this.formulario.controls.numeroProcessoJudicial.value !== null && this.formulario.controls.numeroProcessoJudicial.value !== undefined){
      qtdeDigitosProcesso =  this.formulario.controls.numeroProcessoJudicial.value.length;
    }

    if (this.formulario.controls.numeroProcessoJudicial && qtdeDigitosProcesso === 20) {

      const processoJudicialPrimeiraInstancia =
        await this.processoService.buscarProcesso(this.formulario.controls.numeroProcessoJudicial.value, '1');
      const processoJudicialSegundaInstancia =
        await this.processoService.buscarProcesso(this.formulario.controls.numeroProcessoJudicial.value, '2');

      if (processoJudicialPrimeiraInstancia) {
        processoJudicialPrimeiraInstancia.subscribe(() => {
          this.numeroDoProcessoInvalido = false;
          this.numeroDoProcessoValido = true;
        }, () => {

          this.numeroDoProcessoValido = false;
          this.numeroDoProcessoInvalido = true;
        }, () => {
          if (!this.numeroDoProcessoValido) {
            this.numeroDoProcessoInvalido = true;
          }
        });
      }

      if (processoJudicialSegundaInstancia) {

        processoJudicialSegundaInstancia.subscribe(() => {
          this.numeroDoProcessoInvalido = false;
          this.numeroDoProcessoValido = true;
        }, () => {
          this.numeroDoProcessoValido = false;
          this.numeroDoProcessoInvalido = true;
        }, () => {
          if (!this.numeroDoProcessoValido) {
            this.numeroDoProcessoInvalido = true;
          }
        });

      }
      return null;
    }
  }

  validanumeroProcessoJudicial() {

    const regra = /^[0-9]*$/;
    let numero = '';
    this.numeroDoProcessoValido = false;
    this.numeroDoProcessoInvalido = false;
    if (this.formulario.controls.numeroProcessoJudicial.value !== null) {
      numero = this.formulario.controls.numeroProcessoJudicial.value.trim().replace(/\./g, '').replace(/-/g, '');
    }

    if (this.formulario.controls.numeroProcessoJudicial.value && numero !== '') {

      if (numero.match(regra)) {

        this.isNotNumber = false;

      } else {

        this.isNotNumber = true;
        this.formulario.controls.numeroProcessoJudicial.setValue(numero.substring(0, numero.length - 1));
      }
    }
  }
}
